import ApiService from '../service/ApiService';

let moduleApi = {};
let moduleName = "tv_don_vi_cung_cap_cho_duyet";

moduleApi.list = (dataFilter) => {
    let api = {
        module: moduleName,
        type: "list",
        value: dataFilter
    };
    return ApiService(api);
};

moduleApi.findById = (id) => {
    let api = {
        module: moduleName,
        type: "findById",
        value: { id: id }
    };
    return ApiService(api);
};

moduleApi.create = (dataForm) => {
    let api = {
        module: moduleName,
        type: "create",
        value: dataForm,
    };
    return ApiService(api);
};

moduleApi.update = (dataForm) => {
    let api = {
        module: moduleName,
        type: "partialUpdate",
        value: dataForm
    };
    return ApiService(api);
};

moduleApi.delete = (id) => {
    let api = {
        module: moduleName,
        type: "delete",
        value: { id: id }
    };
    return ApiService(api);
};

moduleApi.approvedDonVi = (dataForm) => {
    let api = {
        module: moduleName,
        type: "approvedDonVi",
        value: dataForm,
        message: {
            success: "Cập nhật thành công", //string | null | comment
            error: "Cập nhật không thành công", //string | null | comment
        },
    };
    return ApiService(api);
};

moduleApi.registerTrangVang = (dataForm) => {
    let api = {
        module: moduleName,
        type: "registerTrangVang",
        value: dataForm,
        message: {
            success: "Chúng tôi đã nhận được yêu cầu tham gia Trang vàng và đang trong quá trình chờ duyệt. Cảm ơn bạn đã tham gia Trang vàng.", //string | null | comment
        },
    };
    return ApiService(api);
};

moduleApi.updateEmail = (dataForm) => {
    let api = {
        module: moduleName,
        type: "updateEmail",
        value: dataForm,
        message: {
            success: null
        },
    };
    return ApiService(api);
};



export default moduleApi;
